/* Neubau D · Bau dein eigenes Bundle, neue Fassung (sections/d-byob-neu.liquid, Vorlage: Ideen-Takt Runde 2).
   Daten kommen als JSON aus Liquid (echte Varianten, Preise in Cent). Eine Zeile im Bundle = eine Variante + Menge.
   Rechnung wie die Kasse (DollarLabs): Stufe nach Teilen ohne Streichpreis, Rabatt je Stück auf den Cent abgeschnitten, mal Menge.
   In die Tüte: ein /cart/add.js; `_byob: '1'` und `_byob_category` nur auf Zeilen ohne Streichpreis (wie d-byob.js).
   Danach kd:cart-added auf document → d-cart.js lädt die Tüte neu und öffnet #kd-cart.
   Start-Sets legen echte Zeilen in den Baukasten; sie bleiben dort frei änderbar. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const fill = (tpl, vals) => Object.entries(vals).reduce((t, [k, v]) => t.split(`__${k}__`).join(String(v)), tpl || '');
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  // Rabatt je Stück, abgerundet wie die Warenkorb-Zuteilung (3049 × 15 % = 457).
  const off = (price, pct) => Math.floor((price * pct) / 100);
  const cents = (p) => (typeof p === 'number' ? p : Math.round(Number(p) * 100));
  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || (window.KD_CFG && window.KD_CFG.routes && window.KD_CFG.routes.root) || '/';
  const url = (p) => { const r = root(); return (r.endsWith('/') ? r : r + '/') + p; };
  /* Farbtupfer je Farbschlüssel (sprachunabhängig, Schlüssel aus snippets/d-byob-neu-color.liquid) */
  const COL = {
    weiss: '#f3f3f3', schwarz: '#151515', pink: '#ff5aa5', ungebleicht: '#c8a77d', gruen: '#2f9e5f', blau: '#3a7bd5', beige: '#e8d9bf',
    peach: '#ffb28a', rot: '#e23b3b', lila: '#8f5bd6', hellbraun: '#b9875a', babyblau: '#8fd3f0', glow: '#d6f2b4',
    mixed: 'linear-gradient(90deg,#151515 50%,#f3f3f3 50%)',
  };

  function init(box) {
    if (!box || box.kbn) return;
    box.kbn = true;
    let D, S;
    try { D = JSON.parse($('[data-kbn-data]', box).textContent); S = JSON.parse($('[data-kbn-strings]', box).textContent); } catch (e) { console.warn('[d-byob-neu] Daten fehlen', e); return; }
    const ds = box.dataset;
    const T1Q = parseInt(ds.tier1Qty, 10) || 3, T1P = parseFloat(ds.tier1Pct) || 0;
    const T2Q = parseInt(ds.tier2Qty, 10) || 5, T2P = parseFloat(ds.tier2Pct) || 0;
    const lang = ds.lang || 'de';
    const money = (c) => (c / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ' + (S.currency || '€');
    const teile = (n) => (n === 1 ? S.itemsOne : fill(S.items, { N: n }));
    const pctFor = (n) => (n >= T2Q ? T2P : n >= T1Q ? T1P : 0);
    const icon = (n) => { const t = $(`template[data-kbn-icon="${n}"]`, box); return t ? t.innerHTML.trim() : ''; };
    const IC = { plus: icon('plus'), minus: icon('minus'), check: icon('check'), truck: icon('truck'), caret: icon('caret') };
    const dock = $('#kbn-dock') || $('#kbn-dock', box);
    const phone = window.matchMedia('(max-width: 899px)');
    /* Zusammenfassung (Computer) und Blatt (Handy) tragen dieselben data-kbn-*-Felder */
    const all = (s) => [...$$(s, box), ...(dock && !box.contains(dock) ? $$(s, dock) : [])];

    /* ---------- Artikel aus den Daten ---------- */
    const P = []; const PBY = new Map(); const V = new Map(); const HV = new Map();
    const CATS = [];
    const parseLines = (txt) => String(txt || '').split(/\r?\n/).map((l) => l.split('|').map((x) => x.trim())).filter((a) => a[0]);
    const lastWord = (t) => String(t).trim().split(/\s+/).pop();
    const dropLast = (t) => { const w = String(t).trim().split(/\s+/); w.pop(); return w.join(' '); };

    function mkProduct(p, ci, names) {
      const nm = names[p.h];
      const single = p.v.length === 1;
      const opts = single ? [] : p.o.map((o) => ({ n: o.n, vals: o.v, color: o.v.length > 0 && o.v.every((v) => v.k) }));
      const ci2 = opts.findIndex((o) => o.color);
      /* Ohne Farbe und mit zwei Optionen: erste als Umschalter (pre), zweite als Chips */
      const pre = ci2 < 0 && opts.length === 2 ? 0 : -1;
      const si = pre === 0 ? 1 : opts.findIndex((o, i) => i !== ci2);
      const prod = {
        key: p.h, cat: ci, h: p.h, url: p.url, pl: p.pl || 'paper', cut: p.cut || '',
        n: (lang === 'de' && nm && nm[1]) || p.n || p.t,
        sub: (nm && nm[2] && S.subs[nm[2]]) || p.sub || '',
        opts, ci: ci2, si, pre, vs: [],
      };
      prod.vs = p.v.map((v) => {
        const cl = ci2 >= 0 ? v.o[ci2] : '';
        const ck = ci2 >= 0 ? ((opts[ci2].vals.find((x) => x.l === cl) || {}).k || '') : '';
        return { id: v.id, o: v.o, p: v.p, c: v.c, a: v.a, img: v.img, own: v.own, h: p.h, prod, cl, ck, sl: si >= 0 ? v.o[si] : '', promo: v.c > v.p };
      });
      return prod;
    }
    /* Mehrere Einzelprodukte (z. B. Rolling Trays je Farbe) als eine Zeile mit Farbtupfern; jede Farbe bleibt ihr eigenes Produkt */
    function group(list, prefix, names, ci) {
      if (!prefix) return list;
      const keyOf = (h) => h.slice(prefix.length);
      const members = list.filter((p) => p.h.startsWith(prefix) && p.vs.length === 1 && COL[keyOf(p.h)]);
      if (members.length < 2) return list;
      const first = members[0];
      const nm = names[prefix] || names[prefix.replace(/-$/, '')] || names[prefix + '*'];
      const g = {
        key: prefix, cat: ci, h: prefix, url: first.url, pl: first.pl,
        n: (lang === 'de' && nm && nm[1]) || dropLast(first.n), sub: (nm && nm[2] && S.subs[nm[2]]) || '',
        opts: [{ n: '', color: true, vals: members.map((m) => ({ l: lastWord(m.n), k: keyOf(m.h) })) }], ci: 0, si: -1, vs: [],
      };
      g.vs = members.map((m) => Object.assign(m.vs[0], { prod: g, o: [lastWord(m.n)], cl: lastWord(m.n), ck: keyOf(m.h), sl: '' }));
      const at = list.indexOf(first);
      const rest = list.filter((p) => members.indexOf(p) < 0);
      rest.splice(Math.min(at, rest.length), 0, g);
      return rest;
    }
    function ordered(list, order) {
      const want = parseLines(order).map((a) => a[0]);
      if (!want.length) return list;
      const pos = (p) => { const i = want.indexOf(p.h); return i < 0 ? want.length : i; };
      return list.map((p, i) => [p, i]).sort((a, b) => pos(a[0]) - pos(b[0]) || a[1] - b[1]).map((x) => x[0]);
    }
    (D.cats || []).forEach((c, ci) => {
      const names = {}; parseLines(c.names).forEach((a) => { names[a[0]] = a; });
      let list = (c.products || []).filter((p) => p.v && p.v.length).map((p) => mkProduct(p, ci, names));
      list = ordered(group(list, c.group, names, ci), c.order);
      list.forEach((p) => { P.push(p); PBY.set(p.key, p); p.vs.forEach((v) => { V.set(String(v.id), v); if (!HV.has(v.h)) HV.set(v.h, []); HV.get(v.h).push(v); }); });
      CATS.push({ dcat: c.dcat, title: c.title, sub: c.sub, items: list });
    });
    const firstImg = (p) => { const v = p.vs.find((x) => x.a && x.img) || p.vs.find((x) => x.img); return v ? v.img : ''; };
    P.forEach((p) => { p.img = firstImg(p); });

    /* ---------- Zustand ---------- */
    let L = []; /* [{ id, q }] in Reihenfolge des Antippens */
    const curSize = {}; const lastV = {}; const open = {};
    let activeSet = null, undo = null, sheetOpen = false, cartTotal = D.cartTotal || 0;
    const qOf = (id) => { const l = L.find((x) => String(x.id) === String(id)); return l ? l.q : 0; };
    function change(id, d) {
      const v = V.get(String(id)); if (!v) return;
      let l = L.find((x) => String(x.id) === String(id));
      if (l) l.q += d; else if (d > 0) L.push(l = { id: v.id, q: d });
      if (l && l.q <= 0) L.splice(L.indexOf(l), 1);
      if (d > 0) lastV[v.prod.key] = v;
      render();
    }
    function calc(lines) {
      let n = 0, sub = 0, save = 0;
      lines.forEach((l) => { const v = V.get(String(l.id)); sub += v.p * l.q; if (!v.promo) n += l.q; });
      const pct = pctFor(n); /* Aktionspreise zählen nicht zur Stufe und bekommen keinen Rabatt */
      lines.forEach((l) => { const v = V.get(String(l.id)); if (!v.promo) save += off(v.p, pct) * l.q; });
      return { n, sub, pct, save, pay: sub - save, lines, promo: lines.some((l) => V.get(String(l.id)).promo) };
    }
    const vLabel = (v) => (v.prod.opts.length ? v.o.join(' · ') : '');

    /* ---------- Start-Sets ---------- */
    const SETS = (D.sets || []).map((s) => Object.assign({}, s, { lines: {} }));
    function resolveSet(s, type) {
      const fh = type === 'star' ? D.star : D.soft;
      const fv = HV.get(fh) || [];
      const out = [];
      const add = (v, q) => { const l = out.find((x) => x.id === v.id); if (l) l.q += q; else out.push({ id: v.id, q }); };
      const cols = String(s.colors || '').split(',').map((x) => x.trim().toLowerCase()).filter(Boolean);
      for (const ck of cols) { const v = fv.find((x) => x.ck === ck && x.a); if (!v) return null; add(v, 1); }
      for (const a of parseLines(s.extras)) {
        const vs = HV.get(a[0]) || []; const want = (a[1] || '').toLowerCase(); const q = Math.max(1, parseInt(a[2], 10) || 1);
        let v;
        if (/^\d+$/.test(want)) v = vs.find((x) => String(x.id) === want);
        else if (want) v = vs.find((x) => x.ck === want || x.o.some((o) => String(o).toLowerCase() === want));
        else v = vs.find((x) => x.a) || vs[0];
        if (!v || !v.a) return null;
        add(v, q);
      }
      return out.length ? out : null;
    }
    SETS.forEach((s) => {
      s.lines.soft = resolveSet(s, 'soft'); s.lines.star = resolveSet(s, 'star');
      if (!s.lines[s.type]) s.type = s.lines.soft ? 'soft' : 'star';
      if (!s.lines.soft && !s.lines.star) console.warn(`[d-byob-neu] Start-Set „${s.name}“ ausgeblendet: Artikel nicht im Baukasten oder ausverkauft.`);
    });
    const liveSets = () => SETS.filter((s) => s.lines.soft || s.lines.star);
    const setLines = (s) => (s.lines[s.type] || []).map((l) => ({ id: l.id, q: l.q }));
    function isOn(s) {
      const want = setLines(s); if (want.length !== L.length) return false;
      return want.every((w) => qOf(w.id) === w.q);
    }
    /* Set-Bild aus echten Einzelfotos: feste Anordnung je Set, nichts überlappt oder ragt über die Platte.
       Maße in Einheiten, eine 250er Packung ist immer 100 hoch; die Bühne (--w × --h) wird in der Platte eingepasst. */
    const PK = [130, 27, 340, 546, 600, 600]; /* sichtbarer Teil der 250er Packshots (x, y, b, h von 600 × 600) */
    const bookCrop = (src) => (/d-papers-unbleached/.test(src) ? [27, 226, 546, 148, 600, 600] : /d-papers-ed\d/.test(src) ? [41, 289, 518, 144, 600, 600] : null);
    function montage(s) {
      const fh = s.type === 'star' ? D.star : D.soft;
      const packs = [], papers = [], zub = [];
      setLines(s).forEach((l) => {
        const v = V.get(String(l.id)); if (!v) return;
        if (v.h === fh) { for (let i = 0; i < l.q; i++) packs.push(v); }
        else if (CATS[v.prod.cat] && CATS[v.prod.cat].dcat === 'papers') papers.push([v, l.q]);
        else zub.push(v);
      });
      const G = 6, PH = 100, PW = PH * PK[2] / PK[3], items = [];
      const put = (cls, src, x, y, w, h, crop, rot) => { if (src) items.push({ cls, src, x, y, w, h, crop, rot }); };
      const packRow = (list, x, y) => list.forEach((v, i) => put('pk', v.img, x + i * (PW + G), y, PW, PH, PK));
      /* Papers: ein Booklet, die Menge als Zahl rechts daneben (nie auf dem Foto) */
      const pq = papers.reduce((a, p) => a + p[1], 0);
      const bSrc = papers.length ? (papers[0][0].prod.cut || papers[0][0].img) : '';
      const bCrop = bookCrop(bSrc), BW = 92, BH = bCrop ? BW * bCrop[3] / bCrop[2] : BW / 3.69, CZ = pq > 1 ? 32 : 0;
      let W, H, cnt = null;
      const bookRow = (y) => {
        const x = (W - BW - CZ) / 2;
        put('bk', bSrc, x, y, BW, BH, bCrop);
        if (pq > 1) cnt = { x: x + BW + G, y: y + BH / 2, t: `${pq}×` };
      };
      if (!zub.length && !papers.length) {
        /* gleiche Bühnenhöhe wie die Sets mit Papers, damit die Packungen auf dem Computer überall gleich groß sind */
        const n = Math.min(packs.length, 3); W = n * PW + (n - 1) * G; H = PH + G + BW / 3.69;
        packRow(packs.slice(0, 3), 0, (H - PH) / 2);
      } else if (!zub.length) {
        const n = Math.min(packs.length, 2), rw = n * PW + (n - 1) * G;
        W = Math.max(rw, BW + CZ); H = (n ? PH + G : 0) + BH;
        packRow(packs.slice(0, 2), (W - rw) / 2, 0); bookRow(n ? PH + G : 0);
      } else {
        /* Packung links; rechts oben Grinder und liegender Clipper, darunter das Tray; unten die Papers */
        const find = (re) => zub.find((v) => re.test(v.h));
        const tray = find(/tray/), grind = find(/grinder/), clip = find(/clipper-feuerzeug/);
        const RX = PW + G, RW = 100, TH = RW * 342 / 576, GH = PH - TH - G, GW = GH * 576 / 508, CW = RW - GW - G, CH = CW * 130 / 576;
        W = RX + RW; H = PH + (papers.length ? G + BH : 0);
        if (packs[0]) put('pk', packs[0].img, 0, 0, PW, PH, PK);
        if (grind) put('grind', grind.img, RX, 0, GW, GH);
        if (clip) put('clip', clip.img, RX + GW + G, (GH - CH) / 2, CW, CH, null, true);
        if (tray) put('tray', tray.img, RX, PH - TH, RW, TH);
        if (papers.length) bookRow(PH + G);
      }
      const pc = (a, b) => `${Math.round(a / b * 10000) / 100}%`;
      const h = items.map((it) => {
        let st = 'left:0;top:0;width:100%;height:100%';
        if (it.crop) { const [cx, cy, cw, ch, iw, ih] = it.crop; st = `left:${pc(-cx, cw)};top:${pc(-cy, ch)};width:${pc(iw, cw)};height:${pc(ih, ch)}`; }
        if (it.rot) st = `left:50%;top:50%;width:${pc(it.h, it.w)};height:${pc(it.w, it.h)};transform:translate(-50%,-50%) rotate(-90deg)`;
        return `<span class="kbn-it kbn-it--${it.cls}" style="left:${pc(it.x, W)};top:${pc(it.y, H)};width:${pc(it.w, W)};height:${pc(it.h, H)}">` +
          `<img src="${esc(it.src)}" alt="" loading="lazy" style="${st}"></span>`;
      }).join('') + (cnt ? `<span class="kbn-cnt" style="left:${pc(cnt.x, W)};top:${pc(cnt.y, H)}">${cnt.t}</span>` : '');
      return `<span class="kbn-stage" role="img" aria-label="${esc(fill(S.montageLabel, { T: s.name }))}" style="--w:${Math.round(W * 100) / 100};--h:${Math.round(H * 100) / 100}">${h}</span>`;
    }
    function renderSets() {
      const list = $('[data-kbn-sets]', box); if (!list) return;
      const sets = liveSets();
      $('[data-kbn-sets-box]', box).hidden = !sets.length;
      const note = $('[data-kbn-note]', box); $('.kbn-ks', box).appendChild(note);
      list.innerHTML = sets.map((s) => {
        const c = calc(setLines(s));
        const types = ['soft', 'star'].filter((t) => s.lines[t]);
        return `<article class="kbn-sv" data-kbn-set="${esc(s.id)}">` +
          `<span class="kd-plate kd-plate--${s.type}">${montage(s)}</span>` +
          `<div class="kbn-sv__top"><div class="kbn-sv__tags"><span class="kd-badge">${esc(teile(c.n))}</span>` + (c.pct ? `<span class="kd-badge kbn-badge--save">${esc(fill(S.setSaved, { P: c.pct }))}</span>` : '') + '</div>' +
          `<h3 class="kbn-sv__name">${esc(s.name)}</h3>` +
          `<div class="kbn-sv__price"><b>${money(c.pay)}</b>` + (c.save ? `<span>${esc(fill(S.setSingle, { A: money(c.sub) }))}</span><span><strong>${esc(fill(S.setSave, { A: money(c.save) }))}</strong></span>` : '') + '</div></div>' +
          `<p class="kbn-sv__sub">${esc(s.sub)}${s.type === 'star' ? ' ' + esc(S.starNote) : ''}</p>` +
          '<div class="kbn-sv__act">' + (types.length > 1 ? `<div class="kbn-dp" role="radiogroup" aria-label="${esc(fill(S.setType, { T: s.name }))}">` +
            types.map((t) => `<button class="kbn-dp__c" type="button" role="radio" aria-checked="${s.type === t}" data-kbn-type="${t}" data-kbn-for="${esc(s.id)}" data-v="${t}"><i></i>${esc(S[t])}</button>`).join('') + '</div>' : '') +
          `<button class="kd-btn kd-btn--line" type="button" data-kbn-pick="${esc(s.id)}"></button></div></article>`;
      }).join('');
    }

    /* ---------- Bereiche und Zeilen ---------- */
    const rowId = (p) => 'kbn-r-' + p.key.replace(/[^a-z0-9_-]/gi, '');
    const plate = (p, src, cls) => `<span class="kd-plate kd-plate--${esc(p.pl)}${cls ? ' ' + cls : ''}">${src ? `<img src="${esc(src)}" alt="" loading="lazy" width="300" height="300">` : ''}</span>`;
    const sizeVals = (p) => (p.si >= 0 ? p.opts[p.si].vals.map((x) => x.l) : []);
    const vFor = (p, size, color) => p.vs.find((v) => (p.si < 0 || v.o[p.si] === size) && (p.ci < 0 || v.o[p.ci] === color));
    function rowHtml(p) {
      let ctl = '';
      if (p.ci >= 0) {
        if (p.si >= 0) {
          const sv = sizeVals(p);
          const differ = sv.some((x) => { const a = p.vs.find((v) => v.o[p.si] === x), b = p.vs.find((v) => v.o[p.si] === sv[0]); return a && b && a.p !== b.p; });
          ctl += `<div class="kbn-seg" role="radiogroup" aria-label="${esc(p.opts[p.si].n || S.sizeGroup)}">` + sv.map((x) => {
            const v = p.vs.find((y) => y.o[p.si] === x);
            return `<button type="button" role="radio" aria-checked="false" data-kbn-seg="${esc(x)}">${esc(x)}${differ && v ? ' · ' + money(v.p) : ''}</button>`;
          }).join('') + '</div>';
        }
        ctl += `<div class="kbn-sw" role="group" aria-label="${esc(S.swatchGroup)}">` + p.opts[p.ci].vals.map((x) =>
          `<button type="button" data-kbn-c="${esc(x.l)}" title="${esc(x.l)}"><i style="--c:${COL[x.k] || '#888'}"></i><b class="kbn-cntb"></b></button>`).join('') + '</div>';
      } else if (p.si >= 0) {
        if (p.pre === 0) {
          ctl += `<div class="kbn-seg" role="radiogroup" aria-label="${esc(p.opts[0].n)}">` + p.opts[0].vals.map((x) => `<button type="button" role="radio" aria-checked="false" data-kbn-pre="${esc(x.l)}">${esc(x.l)}</button>`).join('') + '</div>';
        }
        ctl += '<div class="kbn-chips">' + p.opts[p.si].vals.map((x) => `<button class="kbn-chip" type="button" data-kbn-s="${esc(x.l)}">${IC.plus}${esc(x.l)} <span data-kbn-sp></span><b class="kbn-cntb"></b></button>`).join('') + '</div>';
      } else {
        const v = p.vs[0];
        ctl = v.a
          ? `<button class="kd-btn kd-btn--line kbn-r__add" type="button" data-kbn-inc="${v.id}">${IC.plus}${esc(S.addOne)}</button>` +
            `<span class="kd-qty" hidden><button type="button" data-kbn-dec="${v.id}" aria-label="${esc(fill(S.oneLess, { T: p.n }))}">${IC.minus}</button><output data-kbn-q>0</output>` +
            `<button type="button" data-kbn-inc="${v.id}" aria-label="${esc(fill(S.oneMore, { T: p.n }))}">${IC.plus}</button></span>`
          : `<button class="kd-btn kd-btn--line kbn-r__add" type="button" disabled>${esc(S.soldOut)}</button>`;
      }
      return `<article class="kbn-r" id="${rowId(p)}" data-kbn-p="${esc(p.key)}">` +
        `<a class="kd-plate kd-plate--${esc(p.pl)}" href="${esc(p.url)}" tabindex="-1" aria-hidden="true"><img data-kbn-img src="${esc(p.img)}" alt="" loading="lazy" width="300" height="300"><span class="kbn-r__tag" data-kbn-tag hidden></span></a>` +
        `<div class="kbn-r__txt"><a class="kbn-r__name" href="${esc(p.url)}">${esc(p.n)}</a>${p.sub ? `<span class="kbn-r__sub">${esc(p.sub)}</span>` : ''}</div>` +
        '<div class="kbn-r__price"><b data-kbn-p-now></b><small data-kbn-pp hidden></small></div>' +
        `<div class="kbn-r__ctl">${ctl}</div><div class="kbn-r__lines" data-kbn-pills></div></article>`;
    }
    function renderCats() {
      const nav = $('[data-kbn-nav]', box), wrap = $('[data-kbn-cats]', box);
      nav.innerHTML = CATS.length > 1 ? CATS.map((c, i) => `<a class="kd-btn kd-btn--line kd-btn--s" href="#kbn-cat-${i}" data-kbn-jump="${i}">${esc(c.title)}<span>${c.items.length}</span></a>`).join('') : '';
      wrap.innerHTML = CATS.map((c, i) => {
        const head = i === 0
          ? `<div class="kbn-kcat__h"><h2 class="kd-h2">${esc(c.title)}</h2>${c.sub ? `<p>${esc(c.sub)}</p>` : ''}</div>`
          : `<button class="kbn-kcat__fold" type="button" data-kbn-fold="${i}" aria-expanded="false" aria-controls="kbn-list-${i}">` +
            `<span><span class="kd-h2">${esc(c.title)}</span><span class="kbn-kcat__sel" data-kbn-selc hidden></span><span class="kbn-kcat__meta">${esc(fill(S.catCount, { N: c.items.length }))}${c.sub ? ' · ' + esc(c.sub) : ''}</span></span>` +
            `<span class="kbn-kcat__go"><span data-kbn-foldtxt>${esc(S.showAll)}</span>${IC.caret}</span>` +
            '<span class="kbn-kcat__peek" aria-hidden="true">' + c.items.slice(0, 4).map((p) => plate(p, p.img)).join('') + (c.items.length > 4 ? `<span class="kbn-more">+${c.items.length - 4}</span>` : '') + '</span></button>';
        return `<section class="kbn-kcat" id="kbn-cat-${i}" data-kbn-cat="${i}" data-open="${i === 0}">${head}` +
          `<div class="kbn-klist" id="kbn-list-${i}"${i === 0 ? '' : ' hidden'}>${c.items.map(rowHtml).join('')}</div></section>`;
      }).join('');
      P.forEach((p) => {
        if (p.ci >= 0 && p.si >= 0) { const sv = sizeVals(p); curSize[p.key] = sv.find((x) => p.vs.some((v) => v.o[p.si] === x && v.a)) || sv[0]; }
        if (p.pre === 0) { const pv = p.opts[0].vals.map((x) => x.l); curSize[p.key] = pv.find((x) => p.vs.some((v) => v.o[0] === x && v.a)) || pv[0]; }
      });
    }

    /* ---------- Anzeigen ---------- */
    function pillHtml(l) {
      const v = V.get(String(l.id)), lb = vLabel(v);
      return `<span class="kbn-ln"><button type="button" data-kbn-dec="${v.id}" aria-label="${esc(fill(S.oneLess, { T: lb }))}">${IC.minus}</button>` +
        `<span class="kbn-ln__l">${v.ck ? `<i style="--c:${COL[v.ck] || '#888'}"></i>` : ''}${esc(lb)} <b>${l.q}×</b></span>` +
        `<button type="button" data-kbn-inc="${v.id}" aria-label="${esc(fill(S.oneMore, { T: lb }))}">${IC.plus}</button></span>`;
    }
    function updateRow(p, r) {
      const row = document.getElementById(rowId(p)); if (!row) return;
      const mine = L.filter((l) => V.get(String(l.id)).prod === p);
      const tot = mine.reduce((a, l) => a + l.q, 0);
      row.classList.toggle('is-sel', tot > 0);
      let u = p.vs[0];
      if (p.ci >= 0) {
        const cs = p.si >= 0 ? curSize[p.key] : null;
        $$('[data-kbn-seg]', row).forEach((b) => b.setAttribute('aria-checked', String(b.dataset.kbnSeg === cs)));
        $$('[data-kbn-c]', row).forEach((b) => {
          const v = vFor(p, cs, b.dataset.kbnC), q = v ? qOf(v.id) : 0, x = !v || !v.a;
          b.disabled = x; b.dataset.kbnV = v ? String(v.id) : '';
          b.classList.toggle('has', q > 0); $('.kbn-cntb', b).textContent = q ? String(q) : '';
          const nm = b.dataset.kbnC + (cs ? ' ' + cs : '');
          b.setAttribute('aria-label', x ? fill(S.soldOutC, { C: nm }) : fill(S.swatchAdd, { C: nm }) + (q ? ', ' + fill(S.inBundle, { N: q }) : ''));
        });
        u = (cs ? p.vs.find((v) => v.o[p.si] === cs && v.a) || p.vs.find((v) => v.o[p.si] === cs) : p.vs.find((v) => v.a)) || u;
      } else if (p.si >= 0) {
        const pre = p.pre === 0 ? curSize[p.key] : null;
        $$('[data-kbn-pre]', row).forEach((b) => b.setAttribute('aria-checked', String(b.dataset.kbnPre === pre)));
        const shown = [];
        $$('[data-kbn-s]', row).forEach((b) => {
          const v = p.vs.find((y) => y.o[p.si] === b.dataset.kbnS && (pre === null || y.o[0] === pre));
          const q = v ? qOf(v.id) : 0, x = !v || !v.a;
          b.disabled = x; b.dataset.kbnV = v ? String(v.id) : '';
          b.classList.toggle('has', q > 0); $('.kbn-cntb', b).textContent = q ? String(q) : '';
          $('[data-kbn-sp]', b).textContent = v ? (x ? S.soldOut : money(v.p)) : '';
          b.setAttribute('aria-label', x ? fill(S.soldOutC, { C: b.dataset.kbnS }) : fill(S.swatchAdd, { C: b.dataset.kbnS }) + (q ? ', ' + fill(S.inBundle, { N: q }) : ''));
          if (v) shown.push(v);
        });
        u = shown.slice().sort((a, b) => a.p - b.p)[0] || u;
      } else {
        const add = $('.kbn-r__add', row), qty = $('.kd-qty', row);
        if (qty) { add.hidden = tot > 0; qty.hidden = tot === 0; $('[data-kbn-q]', row).textContent = tot; }
      }
      $('[data-kbn-pills]', row).innerHTML = p.opts.length ? mine.map(pillHtml).join('') : '';
      const ab = p.ci < 0 && p.si >= 0 && p.vs.some((v) => v.p !== u.p);
      $('[data-kbn-p-now]', row).textContent = ab ? fill(S.from, { A: money(u.p) }) : money(u.p);
      const pp = $('[data-kbn-pp]', row);
      if (u.promo) { pp.hidden = false; pp.textContent = S.fixed; }
      else { pp.hidden = r.pct === 0; if (r.pct) pp.textContent = fill(S.withPct, { P: r.pct, A: money(u.p - off(u.p, r.pct)) }); }
      /* Foto der zuletzt angetippten Variante; hat sie kein eigenes, steht dran, welche Farbe das Foto zeigt */
      const img = $('[data-kbn-img]', row), tag = $('[data-kbn-tag]', row), lv = lastV[p.key];
      const src = lv && lv.img ? lv.img : p.img;
      if (img.getAttribute('src') !== src) img.src = src;
      const shows = lv && !lv.own && lv.ck ? p.vs.find((v) => v.own && v.img === src && v.cl) : null;
      tag.hidden = !shows; if (shows) tag.textContent = fill(S.photoShows, { C: shows.cl });
    }
    function nudgeHtml(r) {
      if (r.n === 0) return fill(S.start, { Q: T1Q, P: T1P, Q2: T2Q, P2: T2P });
      if (r.pct === T2P && r.n >= T2Q) return fill(S.max, { P: T2P });
      if (r.n >= T1Q) return fill(S.active, { A: T1P, R: teile(T2Q - r.n), T: T2P });
      return fill(S.remaining, { R: teile(T1Q - r.n), P: T1P });
    }
    function trackHtml(r) {
      const w = Math.min(100, Math.round((r.n / T2Q) * 100)), m1 = Math.round((T1Q / T2Q) * 100);
      return `<div class="kbn-track" role="progressbar" aria-label="${esc(S.progress)}" aria-valuemin="0" aria-valuemax="${T2Q}" aria-valuenow="${Math.min(r.n, T2Q)}">` +
        `<span class="kbn-track__fill" style="width:${w}%"></span><span class="kbn-track__mk${r.n >= T1Q ? ' is-on' : ''}" style="left:${m1}%"></span><span class="kbn-track__mk${r.n >= T2Q ? ' is-on' : ''}" style="left:100%"></span></div>` +
        `<div class="kbn-track__lb"><span style="left:${m1}%">${esc(fill(S.trackMark, { Q: T1Q, P: T1P }))}</span><span class="is-end">${esc(fill(S.trackMark, { Q: T2Q, P: T2P }))}</span></div>`;
    }
    function linesHtml(r) {
      return r.lines.map((l) => {
        const v = V.get(String(l.id)), p = v.prod, lb = vLabel(v);
        return `<li>${plate(p, v.img)}<span class="kbn-lines__t">${esc(p.n)}<span>${lb ? esc(lb) + ' · ' : ''}${esc(fill(S.each, { A: money(v.p) }))}</span></span>` +
          `<b class="kbn-lines__p">${money(v.p * l.q)}</b>` +
          `<span class="kd-qty"><button type="button" data-kbn-dec="${v.id}" aria-label="${esc(fill(S.oneLess, { T: (p.n + ' ' + lb).trim() }))}">${IC.minus}</button><output>${l.q}</output>` +
          `<button type="button" data-kbn-inc="${v.id}" aria-label="${esc(fill(S.oneMore, { T: (p.n + ' ' + lb).trim() }))}">${IC.plus}</button></span></li>`;
      }).join('');
    }
    function rowsHtml(r) {
      return `<div><dt>${esc(S.rowSingle)}</dt><dd>${money(r.sub)}</dd></div>` +
        (r.pct ? `<div><dt>${esc(fill(S.rowDisc, { P: r.pct }))}</dt><dd>−${money(r.save)}</dd></div>` : `<div><dt>${esc(S.rowDiscNone)}</dt><dd>${esc(fill(S.rowDiscFrom, { Q: T1Q }))}</dd></div>`) +
        `<div class="is-total"><dt>${esc(S.rowPay)}</dt><dd>${money(r.pay)}</dd></div>`;
    }
    function shipHtml(r) {
      const goal = D.ship.goal || 0, tot = cartTotal + r.pay, free = tot >= goal;
      const txt = free ? esc(D.ship.done) : fill(D.ship.left, { A: money(goal - tot) });
      return `<p>${free ? IC.check : IC.truck}<span>${txt}</span></p><div class="kbn-ship__t"><i style="width:${free ? 100 : Math.round((tot / goal) * 100)}%"></i></div>`;
    }
    function render() {
      const r = calc(L);
      P.forEach((p) => updateRow(p, r));
      CATS.forEach((c, i) => {
        const sc = $(`.kbn-kcat[data-kbn-cat="${i}"] [data-kbn-selc]`, box); if (!sc) return;
        const k = L.filter((l) => V.get(String(l.id)).prod.cat === i).reduce((a, l) => a + l.q, 0);
        sc.hidden = k === 0; sc.textContent = fill(S.chosen, { N: k });
      });
      liveSets().forEach((s) => {
        const card = $(`.kbn-sv[data-kbn-set="${CSS.escape(s.id)}"]`, box); if (!card) return;
        const on = activeSet === s.id && isOn(s);
        card.classList.toggle('is-on', on);
        const b = $('[data-kbn-pick]', card); b.innerHTML = on ? IC.check + esc(S.setOn) : esc(S.setPick);
        b.classList.toggle('kd-btn--main', on); b.classList.toggle('kd-btn--line', !on);
      });
      all('[data-kbn-nudge]').forEach((el) => { el.innerHTML = nudgeHtml(r); });
      all('[data-kbn-track]').forEach((el) => { el.innerHTML = trackHtml(r); });
      all('[data-kbn-lines]').forEach((el) => { el.innerHTML = linesHtml(r); });
      all('[data-kbn-rows]').forEach((el) => { el.innerHTML = rowsHtml(r); if (box.contains(el)) el.hidden = !L.length; });
      all('[data-kbn-ship]').forEach((el) => { el.hidden = D.ship.off || !L.length || !D.ship.goal; if (!el.hidden) el.innerHTML = shipHtml(r); });
      const empty = $('[data-kbn-empty]', box); if (empty) empty.hidden = L.length > 0;
      all('[data-kbn-add]').forEach((b) => { if (!b.classList.contains('is-busy')) b.disabled = !L.length; });
      /* Handy: schmale Leiste */
      if (dock) {
        dock.hidden = !L.length;
        box.classList.toggle('has-dock', !!L.length);
        if (dock.hidden && sheetOpen) setSheet(false);
        $('[data-kbn-barprog]', dock).style.width = Math.min(100, Math.round((r.n / T2Q) * 100)) + '%';
        $('[data-kbn-barpay]', dock).textContent = money(r.pay);
        const tier = $('[data-kbn-bartier]', dock); tier.hidden = r.pct === 0; tier.textContent = '−' + r.pct + ' %';
        $('[data-kbn-barsub]', dock).innerHTML = esc(teile(r.n)) + ' · ' + (r.pct ? `<b>${esc(fill(S.barSave, { A: money(r.save) }))}</b>` : esc(fill(S.barLeft, { N: Math.max(0, T1Q - r.n), P: T1P })));
      }
    }

    /* ---------- Handlungen ---------- */
    function placeNote(id) {
      const note = $('[data-kbn-note]', box), card = $(`.kbn-sv[data-kbn-set="${CSS.escape(id)}"]`, box);
      if (!phone.matches) $('[data-kbn-sets]', box).append(note); else if (card) card.after(note);
    }
    function applySet(s) { L = setLines(s); L.forEach((l) => { const v = V.get(String(l.id)); if (v.ck || v.sl) lastV[v.prod.key] = v; }); }
    function pick(id) {
      const s = SETS.find((x) => x.id === id); if (!s || (activeSet === id && isOn(s))) return;
      undo = L.length ? { L: L.map((l) => ({ id: l.id, q: l.q })), set: activeSet } : null;
      applySet(s); activeSet = id;
      placeNote(id);
      const note = $('[data-kbn-note]', box); note.hidden = false;
      const fp = (V.get(String(L[0] && L[0].id)) || {}).prod;
      note.innerHTML = `${IC.check}<span>${fill(S.setNote, { T: esc(s.name) })}${undo ? ' ' + esc(S.setReplaced) : ''}</span>` +
        `<span class="kbn-ks-note__acts">${fp ? `<button class="kd-link" type="button" data-kbn-goto="${esc(fp.key)}">${esc(S.setColors)}</button>` : ''}${undo ? `<button class="kd-link" type="button" data-kbn-undo>${esc(S.setUndo)}</button>` : ''}</span>`;
      render();
    }
    function setType(id, t) {
      const s = SETS.find((x) => x.id === id); if (!s || s.type === t || !s.lines[t]) return;
      const was = activeSet === id && isOn(s);
      s.type = t;
      renderSets();
      if (was) {
        applySet(s);
        const g = $('[data-kbn-note] [data-kbn-goto]', box), fp = (V.get(String(L[0] && L[0].id)) || {}).prod;
        if (g && fp) g.dataset.kbnGoto = fp.key;
      }
      if (!$('[data-kbn-note]', box).hidden && activeSet) placeNote(activeSet);
      render();
    }
    function toggleFold(i, force) {
      open[i] = force === undefined ? !open[i] : force;
      const c = $(`.kbn-kcat[data-kbn-cat="${i}"]`, box); if (!c) return;
      c.dataset.open = String(open[i] || i === 0);
      const list = $(`#kbn-list-${i}`, box); if (list) list.hidden = !open[i] && i !== 0;
      const f = $('[data-kbn-fold]', c); if (f) f.setAttribute('aria-expanded', String(!!open[i]));
      const ft = $('[data-kbn-foldtxt]', c); if (ft) ft.textContent = open[i] ? S.collapse : S.showAll;
    }
    function gotoRow(key) {
      const p = PBY.get(key); if (!p) return;
      if (p.cat > 0) toggleFold(p.cat, true);
      setSheet(false);
      const row = document.getElementById(rowId(p)); if (row) row.scrollIntoView({ block: 'center' });
    }
    function setSheet(on) {
      if (!dock) return;
      sheetOpen = on;
      $('[data-kbn-sheet]', dock).hidden = !on; $('[data-kbn-scrim]', dock).hidden = !on; dock.classList.toggle('is-open', on);
      const info = $('.kbn-bar__info', dock); info.setAttribute('aria-expanded', String(on)); info.setAttribute('aria-label', on ? S.detailsClose : S.detailsOpen);
    }

    /* ---------- In die Tüte ---------- */
    function showError(m) { all('[data-kbn-error]').forEach((el) => { el.hidden = !m; el.textContent = m || ''; }); }
    function flash(b, cls) { b.classList.add(cls); clearTimeout(b.kbnT); b.kbnT = setTimeout(() => b.classList.remove(cls), cls === 'is-err' ? 3200 : 2200); }
    async function add(btn) {
      if (!L.length || btn.classList.contains('is-busy')) return;
      const btns = all('[data-kbn-add]');
      btns.forEach((b) => { b.classList.remove('is-done', 'is-err'); b.classList.add('is-busy'); b.setAttribute('aria-busy', 'true'); });
      showError('');
      const items = L.map((l) => {
        const v = V.get(String(l.id));
        const it = { id: Number(v.id), quantity: l.q };
        if (!v.promo) it.properties = { _byob: '1', _byob_category: (CATS[v.prod.cat] && CATS[v.prod.cat].dcat) || '' };
        return it;
      });
      let ok = false;
      try {
        const r = await fetch(url('cart/add.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        const data = await r.json().catch(() => ({}));
        if (!r.ok || data.status) throw Object.assign(new Error(data.description || data.message || S.error || 'Error'), { data });
        ok = true;
        L = []; activeSet = null; undo = null; $('[data-kbn-note]', box).hidden = true; setSheet(false);
        render();
        const cart = window.KD && window.KD.cartRefresh ? await window.KD.cartRefresh() : null;
        if (cart && typeof cart.total_price === 'number') cartTotal = cart.total_price;
        btns.forEach((b) => flash(b, 'is-done'));
        document.dispatchEvent(new CustomEvent('kd:cart-added', { bubbles: true, detail: { items: data.items || [], item: (data.items && data.items[0]) || null, cart, button: btn, byob: true } }));
      } catch (e) {
        const m = e.data ? e.message : S.network || e.message;
        showError(m);
        btns.forEach((b) => { const sp = b.querySelector('.kd-btn__err span'); if (sp) sp.textContent = S.error || ''; flash(b, 'is-err'); });
        document.dispatchEvent(new CustomEvent('kd:cart-error', { bubbles: true, detail: { message: m, button: btn } }));
      } finally {
        btns.forEach((b) => { b.classList.remove('is-busy'); b.removeAttribute('aria-busy'); });
        if (!ok) render(); else all('[data-kbn-add]').forEach((b) => { b.disabled = !L.length; });
      }
    }

    /* ---------- Live-Produkt (wie d-byob: Preise und Bestand ungecacht) ---------- */
    async function refreshLive(handle) {
      const vs = HV.get(handle); if (!vs || !vs.length) return;
      try {
        const r = await fetch(url(`products/${encodeURIComponent(handle)}.js`), { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        const p = await r.json();
        if (!p || p.handle !== handle || !Array.isArray(p.variants)) throw new Error('invalid product payload');
        p.variants.forEach((x) => {
          const v = vs.find((y) => String(y.id) === String(x.id)); if (!v) return;
          v.p = cents(x.price); v.c = cents(x.compare_at_price || 0); v.a = !!x.available; v.promo = v.c > v.p;
        });
        renderSets(); render();
      } catch (e) {
        console.warn(`[d-byob-neu] ${handle} nicht frisch geladen, Server-Stand bleibt.`, e);
      }
    }

    /* ---------- Ereignisse ---------- */
    const inside = (el) => box.contains(el) || (dock && dock.contains(el));
    document.addEventListener('click', (e) => {
      const t = e.target; if (!t || !t.closest || !inside(t)) return;
      let x, row;
      if ((x = t.closest('[data-kbn-add]'))) { e.preventDefault(); return add(x); }
      if ((x = t.closest('[data-kbn-pick]'))) return pick(x.dataset.kbnPick);
      if ((x = t.closest('[data-kbn-type]'))) return setType(x.dataset.kbnFor, x.dataset.kbnType);
      if ((x = t.closest('[data-kbn-inc]'))) return change(x.dataset.kbnInc, 1);
      if ((x = t.closest('[data-kbn-dec]'))) return change(x.dataset.kbnDec, -1);
      if ((x = t.closest('[data-kbn-c], [data-kbn-s]')) && x.dataset.kbnV) return change(x.dataset.kbnV, 1);
      if ((x = t.closest('[data-kbn-seg]')) && (row = x.closest('.kbn-r'))) { curSize[row.dataset.kbnP] = x.dataset.kbnSeg; return render(); }
      if ((x = t.closest('[data-kbn-pre]')) && (row = x.closest('.kbn-r'))) { curSize[row.dataset.kbnP] = x.dataset.kbnPre; return render(); }
      if ((x = t.closest('[data-kbn-fold]'))) return toggleFold(+x.dataset.kbnFold);
      if ((x = t.closest('[data-kbn-jump]'))) {
        e.preventDefault(); const i = +x.dataset.kbnJump; if (i > 0) toggleFold(i, true);
        const c = $(`#kbn-cat-${i}`, box); if (c) c.scrollIntoView({ block: 'start' }); return;
      }
      if ((x = t.closest('[data-kbn-goto]'))) return gotoRow(x.dataset.kbnGoto);
      if (t.closest('[data-kbn-undo]')) { if (undo) { L = undo.L; activeSet = undo.set; undo = null; } $('[data-kbn-note]', box).hidden = true; return render(); }
      if (t.closest('[data-kbn-sheet-toggle]')) return setSheet(!sheetOpen);
      if (t.closest('[data-kbn-scrim]')) return setSheet(false);
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && sheetOpen) setSheet(false); });
    document.addEventListener('kd:cart-updated', (e) => {
      const c = e.detail && e.detail.cart; if (c && typeof c.total_price === 'number' && c.total_price !== cartTotal) { cartTotal = c.total_price; render(); }
    });
    phone.addEventListener && phone.addEventListener('change', () => { if (!phone.matches) setSheet(false); if (activeSet && !$('[data-kbn-note]', box).hidden) placeNote(activeSet); });

    renderSets(); renderCats(); render();
    if (ds.liveHandle) refreshLive(ds.liveHandle);
  }

  const start = () => $$('[data-kbn]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', (e) => $$('[data-kbn]', e.target).forEach(init));
})();
